// extracted by mini-css-extract-plugin
module.exports = {"modal":"EmailViewModal_modal__3wfxU","form__field":"EmailViewModal_form__field__n43ur","controls":"EmailViewModal_controls__1KdbC","btn":"EmailViewModal_btn__1XU3R"};